export const WIDGET_DEV_1_KEY = '0x4AAAAAAAguBkwCLl34WPfE';
export const WIDGET_PROD_1_KEY = '0x4AAAAAAAiUTkvrWJuSDKCS';
export const WIDGET_PROD_2_KEY = '0x4AAAAAAAiUTXPe4qOERc2E';

const SITE_WIDGETS = [
  {
    key: WIDGET_DEV_1_KEY,
    domains: ['twbox.io', 'twtest.io'],
  },
  {
    key: WIDGET_PROD_1_KEY,
    domains: [
      'treatwell.at',
      'treatwell.be',
      'treatwell.de',
      'treatwell.es',
      'treatwell.fr',
      'treatwell.gr',
      'treatwell.ie',
      'treatwell.it',
      'treatwell.lt',
      'treatwell.nl',
    ],
  },
  {
    key: WIDGET_PROD_2_KEY,
    domains: ['treatwell.ch', 'treatwell.co.uk', 'treatwell.pt'],
  },
];

export const getSitekey = (hostname: string) => {
  const widget = SITE_WIDGETS.find(({domains}) =>
    domains.some((domain) => hostname.endsWith(domain))
  );
  return widget ? widget.key : null;
};
